
// src/pages/AboutPage.jsx
import React from 'react';
import Biography from '../components/about/Biography';
import ContactInfo from '../components/about/ContactInfo';
import AudioPlayer from '../components/library/AudioPlayer';


const AboutPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8 text-gray-100">About</h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <Biography />
        </div>
        <div>
          <ContactInfo />
        </div>
      </div>
      <div className="fixed bottom-0 left-0 right-0 z-50">
        <AudioPlayer />
      </div>
    </div>
  );
};

export default AboutPage;